import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { SearchInput } from '@gem/ui-kit';

import { useSharedDataViewPresenter, ISharedDataViewParams } from './ShareDataView.presenter';
import styles from './ShareDataView.styles.m.css';
import { SharedDataViewTabs } from './SharedDataViewTabs/SharedDataViewTabs';

type TShareDataViewProps = ISharedDataViewParams;

export const ShareDataView: FC<TShareDataViewProps> = observer((props) => {
  const { multiselect = false } = props;

  const { t } = useTranslation();
  const presenter = useSharedDataViewPresenter(props);

  return (
    <>
      <SearchInput
        className={styles.search}
        placeholder={t('main_menu_search_note')}
        onChange={presenter.onSearch}
        value={presenter.searchValue}
      />
      <SharedDataViewTabs
        searchValue={presenter.searchValue}
        selection={presenter.selection}
        multiselect={multiselect}
        onClickItem={presenter.onClickItem}
      />
    </>
  );
});
